const apply = {
  // HeroSection - title and lead
  'apply.hero.title': 'Course Application Form',
  'apply.hero.lead': 'Please complete the form below to submit your course application. All fields marked as required must be filled in before you can proceed to the confirmation screen.',

  // HeroSection
  'apply.hero.homeLink': 'Home',
  'apply.hero.admissionLink': 'Admission Guide',
  'apply.hero.currentPage': 'Application Form',
  'apply.hero.imgAlt': 'A butler poised to welcome applicants',

  // breadcrumb
  'apply.breadcrumb.home': 'Home',
  'apply.breadcrumb.admission': 'Admission Guide',
  'apply.breadcrumb.current': 'Application Form',

  // PreCheckSection
  'apply.precheck.label': 'BEFORE YOU APPLY',
  'apply.precheck.title': 'Please Confirm Before Applying',
  'apply.precheck.titleEn': 'Please Confirm',
  'apply.precheck.lead': 'Before submitting your application, please review the following key points. For full eligibility criteria and step-by-step guidance, visit our ',
  'apply.precheck.applicationLink': 'Eligibility & Application Process',
  'apply.precheck.leadSuffix': ' page.',

  // PreCheckSection items
  'apply.preCheck.item.0.label': 'Aged 18 or over (no high-school students)',
  'apply.preCheck.item.0.desc': 'Aside from the minimum age requirement, there are no restrictions on nationality, gender, or experience.',
  'apply.preCheck.item.1.label': 'First-come, first-served (6 places per intake)',
  'apply.preCheck.item.1.desc': 'Each intake is limited to 6 participants. Applications close once capacity is reached.',
  'apply.preCheck.item.2.label': 'Bank transfer (lump-sum) only',
  'apply.preCheck.item.2.desc': 'Instalment plans and credit card payments are not accepted.',
  'apply.preCheck.item.3.label': 'Application deadline: 14 days before course start',
  'apply.preCheck.item.3.desc': 'A minimum of 3 participants is required. If not met, a full refund or transfer to the next session (with 5% discount) will be offered.',

  // ApplicationForm
  'apply.form.label': 'APPLICATION FORM',
  'apply.form.title': 'Course Application Form',
  'apply.form.titleEn': 'Course Application',
  'apply.form.requiredNote': 'Fields marked as required must be completed before you can proceed to the confirmation screen.',
  'apply.form.requiredBadge': 'Required',
  'apply.form.optionalBadge': 'Optional',
  'apply.form.altContact': 'You may also reach us by telephone',
  'apply.form.altContactHours': '(weekdays, 10:00 – 17:00) or by email at',
  'apply.form.altContactSuffix': '.',
  'apply.form.nameLabel': 'Full Name',
  'apply.form.furiganaLabel': 'Name (Phonetic Reading)',
  'apply.form.emailLabel': 'Email Address',
  'apply.form.phoneLabel': 'Phone Number',
  'apply.form.courseLabel': 'Desired Course',
  'apply.form.termLabel': 'Preferred Session',
  'apply.form.termPlaceholder': 'Please select',
  'apply.form.transferLabel': 'Lateral Enrollment Discount',
  'apply.form.transferNote': '* Select only if applicable. For details, refer to the ',
  'apply.form.transferNoteLink': 'course overview',
  'apply.form.transferNoteSuffix': '.',
  'apply.form.motivationLabel': 'Motivation for Applying',
  'apply.form.namePlaceholder': 'e.g. James Smith',
  'apply.form.furiganaPlaceholder': 'e.g. James Smith (roman)',
  'apply.form.phonePlaceholder': 'e.g. 090-1234-5678',
  'apply.form.emailPlaceholder': 'e.g. taro@example.com',
  'apply.form.course.essential': 'Essential Course',
  'apply.form.course.advanced': 'Advanced Course',
  'apply.form.course.master': 'Master Course',
  'apply.form.motivationPlaceholder': 'Please share how you first heard about the academy and what motivated you to apply. Feel free to write freely.',
  'apply.form.consultLabel': 'Individual Consultation Request',
  'apply.form.consultYes': 'Yes, I would like a consultation',
  'apply.form.consultNo': 'No, not at this time',
  'apply.form.privacyLabel': 'I agree to the',
  'apply.form.privacyLink': 'Privacy Policy',
  'apply.form.submitBtn': 'Proceed to Confirmation',

  // Validation messages
  'apply.form.error.name': 'Full name is required.',
  'apply.form.error.furigana': 'Phonetic reading is required.',
  'apply.form.error.emailRequired': 'Email address is required.',
  'apply.form.error.emailInvalid': 'Please enter a valid email address.',
  'apply.form.error.phone': 'Phone number is required.',
  'apply.form.error.course': 'Please select a course.',
  'apply.form.error.consultation': 'Please indicate your consultation preference.',
  'apply.form.error.motivation': 'Please limit your response to 500 characters.',
  'apply.form.error.privacy': 'You must agree to the Privacy Policy to proceed.',

  // PostSubmitGuide
  'apply.post.label': 'AFTER SUBMISSION',
  'apply.post.title': 'After You Submit',
  'apply.post.titleEn': 'What Happens Next',
  'apply.post.lead': 'After you submit your form, a member of our team will contact you within two business days to provide your enrollment agreement and payment instructions. Your enrollment is confirmed upon receipt of bank transfer payment.',
  'apply.post.step1.num': '01',
  'apply.post.step1.title': 'Auto-reply Email',
  'apply.post.step1.desc': 'A confirmation email will be sent automatically to the address you entered.',
  'apply.post.step2.num': '02',
  'apply.post.step2.title': 'Contact from Our Team',
  'apply.post.step2.desc': 'Within two business days, a staff member will reach out with your enrollment agreement and payment details.',
  'apply.post.step3.num': '03',
  'apply.post.step3.title': 'Enrollment Confirmed',
  'apply.post.step3.desc': 'Once your bank transfer payment is received, your enrollment is officially confirmed and we will send start-date information.',

  // AlternativeContact
  'apply.altContact.label': 'OTHER WAYS',
  'apply.altContact.title': 'Other Ways to Apply',
  'apply.altContact.titleEn': 'Alternative Contact Methods',
  'apply.altContact.lead': 'In addition to this form, you are welcome to enquire about enrollment by telephone or email.',
  'apply.altContact.phone.title': 'Telephone',
  'apply.altContact.phone.hours': 'Weekdays, 10:00 – 17:00',
  'apply.altContact.email.title': 'Email',
  'apply.altContact.email.hours': 'Accepted 24 hours (replies during business hours)',
  'apply.altContact.note': '* While we are happy to answer enquiries by telephone or email, formal applications must be submitted via this form.',

  // Terms (preferred session options)
  'apply.form.term.2026-autumn': 'Autumn 2026 (September start)',
  'apply.form.term.2027-spring': 'Spring 2027 (April start)',
  'apply.form.term.2027-autumn': 'Autumn 2027 (September start)',
  'apply.form.term.undecided': 'Undecided (happy to discuss)',

  // Transfer discount options
  'apply.form.transfer.none': 'None',
  'apply.form.transfer.essential-completed': 'E-Course graduate (Essential completed)',
  'apply.form.transfer.advanced-completed': 'A-Course graduate (Advanced completed)',

  // Course comparison link
  'apply.courseCompare': 'Compare courses',

  // FAQSection
  'apply.faq.label': 'FAQ',
  'apply.faq.title': 'Frequently Asked Questions',
  'apply.faq.titleEn': 'Frequently Asked Questions',
  'apply.faq.contactNote': 'For further questions, please use our ',
  'apply.faq.contactLink': 'contact form',
  'apply.faq.contactSuffix': '.',

  // FAQ items
  'apply.faq.0.question': 'What happens after I apply?',
  'apply.faq.0.answer': 'Within two business days, we will contact you to send your enrollment agreement and payment instructions. Your place is confirmed once bank transfer payment is received.',
  'apply.faq.1.question': 'Can I cancel my application?',
  'apply.faq.1.answer': 'Cancellations are accepted within a specified period. Full details will be provided in your enrollment agreement.',
  'apply.faq.2.question': 'Can I apply by phone?',
  'apply.faq.2.answer': 'We are happy to answer enquiries by telephone (weekdays, 10:00 – 17:00), but formal applications must be submitted via this form.',

  // RelatedPages
  'apply.related.label': 'LEARN MORE',
  'apply.related.title': 'Related Pages',
  'apply.related.titleEn': 'Explore Further',
  'apply.related.arrowLabel': 'Learn more',

  // Related pages items
  'apply.related.item.0.title': 'Eligibility & Application Process',
  'apply.related.item.0.desc': 'Eligibility criteria and application steps',
  'apply.related.item.1.title': 'Individual Consultation',
  'apply.related.item.1.desc': 'Free consultation, also available online',
  'apply.related.item.2.title': 'Course Overview',
  'apply.related.item.2.desc': 'Compare all three courses at a glance',
  'apply.related.item.3.title': 'Annual Schedule',
  'apply.related.item.3.desc': 'Course start dates and class timetable',

  // footer
  'apply.footer.lastUpdated': 'Last updated: 13 June 2026',
  'apply.backToTop.ariaLabel': 'Back to top',

  // Confirm page
  'apply.confirm.breadcrumb.apply': 'Application Form',
  'apply.confirm.breadcrumb.current': 'Confirm',
  'apply.confirm.title': 'Review Your Application',
  'apply.confirm.lead': 'Please check the details below. If everything looks correct, click "Submit" to send your application.',
  'apply.confirm.privacyLabel': 'Privacy Policy',
  'apply.confirm.privacyAgreed': 'Agreed',
  'apply.confirm.editBtn': 'Go Back & Edit',
  'apply.confirm.submitBtn': 'Submit Application',
  'apply.confirm.submitting': 'Submitting...',
  'apply.confirm.errorDefault': 'Submission failed. Please try again or contact us by telephone at 03-6824-4086.',
  'apply.confirm.errorNetwork': 'A network error occurred. Please check your internet connection and try again.',
  'apply.confirm.fields.name': 'Full Name',
  'apply.confirm.fields.furigana': 'Name (Phonetic Reading)',
  'apply.confirm.fields.email': 'Email Address',
  'apply.confirm.fields.phone': 'Phone Number',
  'apply.confirm.fields.desiredCourse': 'Desired Course',
  'apply.confirm.fields.preferredTerm': 'Preferred Session',
  'apply.confirm.fields.transferDiscount': 'Lateral Enrollment Discount',
  'apply.confirm.fields.motivation': 'Motivation for Applying',
  'apply.confirm.fields.consultationDesired': 'Consultation Request',
  'apply.confirm.fields.consultYes': 'Requested',
  'apply.confirm.fields.consultNo': 'Not requested',
  'apply.confirm.fields.empty': '(Not provided)',

  // Complete page
  'apply.complete.title': 'Thank You for Your Application',
  'apply.complete.p1': 'A confirmation email has been sent to the address you provided.',
  'apply.complete.p2': 'A member of our team will contact you within two business days to send your enrollment agreement and payment instructions. Your place will be confirmed upon receipt of payment.',
  'apply.complete.coursesBtn': 'View Course Overview',
  'apply.complete.homeBtn': 'Return to Home',
};

export default apply;
